import { defineMessages } from "react-intl";

export default defineMessages({
    help: {
        id: "components.header.headerSettings.help",
        defaultMessage: "Help",
    },
});
